export const backButtonTemplate = {
  excludePaths: [
    '/game/mutelu',
    '/game/mutelu/mutelu-main',
    '/game/mutelu/main-member',
    '/game/mutelu/activity',
    '/game/mutelu/submit-receipt',
    '/game/mutelu/receipt'
  ],
  className:
    'absolute left-1 top-1 z-40 h-8 w-8 text-[#5b461c] transition hover:opacity-75'
}
